import i18n from '@/utils/i18n';
import React from 'react';
import { CATALOG_ROUTES } from '@/navigators/routes';
import { CatalogStackParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';
import { VolumePromotionsList } from '@/components/orders/volume-promotions-list';

type Props = StackScreenProps<
  CatalogStackParams,
  CATALOG_ROUTES.VolumePromotionsList
>;

export const CatalogVolumePromotionsListScreen: React.FC<Props> = ({
  navigation,
}) => {
  return (
    <VolumePromotionsList
      headerBackButtonLabel={i18n.t('back_to', { name: i18n.t('catalog') })}
      onNavigateToDetails={(promotionUUID) => {
        navigation.navigate(CATALOG_ROUTES.VolumePromotionDetail, {
          promotionUUID,
        });
      }}
    />
  );
};
